import React, { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import "./EditMyTechProfileSkills.css";
import { useDispatch, useSelector } from "react-redux";
import { setProfileState } from "../../../actions/MyTechProfile/myTechProfileActions";
import { allSkills } from "../../../utils/constants";

// All skills data is now self-contained within this component.

const EditMyTechProfileSkills = ({ scrollTo }) => {
  const { profile } = useSelector((state) => state.editMyTechProfileStore);
  const dispatch = useDispatch();
  // State for selected skills and UI is now managed locally.
  const [selectedSkills, setSelectedSkills] = useState([
    // Initial data can be set here. For this example, we start with two skills.
    allSkills[0], // React
    allSkills[1], // Node.js
  ]);
  const [isAddingSkill, setIsAddingSkill] = useState(false);

  useEffect(() => {
    if (profile) {
      setSelectedSkills(profile?.selectedSkills);
    }
  }, [profile]);

  // Handlers now update local state.
  const handleSkillSelect = (event, value) => {
    if (value && !selectedSkills.find((skill) => skill.id === value.id)) {
      setSelectedSkills([...selectedSkills, value]);
      dispatch(
        setProfileState({
          ...profile,
          selectedSkills: [...selectedSkills, value],
        })
      );
    }
    setIsAddingSkill(false);
  };

  const handleSkillRemove = (skillToRemove) => {
    setSelectedSkills(
      selectedSkills.filter((skill) => skill.id !== skillToRemove.id)
    );
    dispatch(
      setProfileState({
        ...profile,
        selectedSkills: selectedSkills.filter(
          (skill) => skill.id !== skillToRemove.id
        ),
      })
    );
  };

  return (
    <Box>
      <div className="editmytechprofile-skills-wrapper">
        {selectedSkills.map((skill) => (
          <div key={skill.id} className="editmytechprofile-skill-chip selected">
            <img
              src={skill.icon}
              alt={skill.name}
              className="editmytechprofile-skill-icon"
            />
            <span>{skill.name}</span>
            <Cancel
              sx={{ fontSize: "18px", marginLeft: "10px", cursor: "pointer" }}
              onClick={() => {
                scrollTo("skills");
                handleSkillRemove(skill);
              }}
            />
          </div>
        ))}
      </div>
      {!isAddingSkill ? (
        <span
          className="editmytechprofile-add-skill-text"
          onClick={() => {
            scrollTo("skills");
            setIsAddingSkill(true);
          }}
        >
          + add more skills
        </span>
      ) : (
        <Autocomplete
          fullWidth
          openOnFocus
          options={allSkills.filter(
            (s) => !selectedSkills.find((ss) => ss.id === s.id)
          )}
          onFocus={() => scrollTo("skills")}
          getOptionLabel={(option) => option.name}
          onChange={handleSkillSelect}
          onBlur={() => setIsAddingSkill(false)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select skill"
              variant="outlined"
              size="small"
              autoFocus
            />
          )}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <img
                src={option.icon}
                alt={option.name}
                className="editmytechprofile-skill-icon"
                style={{ marginRight: 8 }}
              />
              {option.name}
            </Box>
          )}
        />
      )}
    </Box>
  );
};

export default EditMyTechProfileSkills;
